import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 235;

export const useStyles = makeStyles(theme => ({
    avatarRoot: {
        justifyContent: 'center',
        display: 'flex',
    },
    containerEmployeeCard:{
        marginTop: 0,
        paddingBottom: '0px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: 0,
        height: '100%'
    },
    rootEmployeeCard : {
        padding: theme.spacing(3,2),
        display: 'flex',
        width: '50%',
        alignItems: 'center',
    },
    gridSeparatorTop:{
        marginTop: '15px'
    },
    gridSeparatorTopButton:{
        marginTop: '15%'
    },
    gridItem: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'justify',
    },
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
        paddingLeft: 10,
        backgroundColor: '#fbfbfb',

    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: 0,
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: '999',
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
        color:'#2a4a84'
    },
    drawerPaper: {
        background:'#001c33',
        position: 'static',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(5),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(5),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    listItemText: {
        fontSize: '13px',//Insert your required size
        color:'#fff'
    },
    listItemTextChildren: {
        fontSize: '12px',//Insert your required size
        color:'#fff',
    },
    drawer:{
        width: '25%'
    },
    nested: {
        paddingLeft: theme.spacing(2),
        paddingBottom:1,
        paddingTop:1,
        backgroundColor:'#002B4D',
        "&.Mui-selected": {
            backgroundColor: "#1e6588d9",
          },
    },
    nestedSingle: {
        paddingLeft: '10px', 
        paddingRight: '24px',
        "&.Mui-selected": {
            backgroundColor: "#1b99d6d9",
            '&:hover': {
                background: "#0e4f6dd9",
             },
        },
        '&:hover': {
            background: "#0e4f6dd9",
         },
    },
    containerHeaderNav:{
          padding:0
    },

    menuFoldStyle:{
        justifyContent: 'flex-end',
        display: 'flex'
    },
    version: {
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        color:'#EAEAEA'
    },
    content1: {
        display: 'grid',
        gridTemplateColumns: 'repeat(1,1fr)',
        gridGap: 0,
        height: '100%',
        marginTop: '19px'
    },
    poweredByTic:{
        justifyContent: 'flex-end',
        display: 'flex',
    },
    collapseBG:{
        backgroundColor:'#002B4D'
    }
}));

export const styles = ({
    listPadding: {
        padding: 0
    },
    ticText: {
        fontSize: '1.2em',
        fontWeight: 'bold',
        color: '#233E84'
    },
    companyText: {
        fontSize: '0.65em',
    },
    bigText:{
        color: '#666666', paddingRight: '10px'
    },
    byText:{
        fontSize: '1.1em', color: 'gray'
    },
    poweredText:{
        fontWeight: 'bold', color:'#CC0000'
    },
    menuIcons:{
        color: '#98d3f1',
        fontSize: '20px'
    },
    menuUpDown:{
        color: '#98d3f1',
    },
})

//1e6588d9